import React from 'react';
import { PULSE_LOGO } from '../../data/team';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`relative inline-block h-8 w-[68px] overflow-hidden rounded-lg bg-pulse-600 ${className}`} data-id="element-688" data-mp="wo4gt6eiv22x">
      <img src={PULSE_LOGO} alt="Pulse" className="h-full w-full scale-[1.85] object-cover" data-id="element-689" data-mp="rua1ef5y999n" />
    </span>;
}